import { Control, Controller } from "react-hook-form";
import { EmailPreview } from "../../components/EmailPreview";
import { RichTextInput, TextInput } from "../../components/form";
import { EmailTemplate } from "../../models/notification";
import { AcademicEmailComposerFormValues } from "./AcademicEmailComposerForm.Types";

interface AcademicEmailComposerFormStep2Props {
  control: Control<AcademicEmailComposerFormValues>;
  formValues: AcademicEmailComposerFormValues;
  emailTemplate: EmailTemplate;
  getEmailTemplateVariables: (values: AcademicEmailComposerFormValues) => any;
  goBack: () => void;
}

const AcademicEmailComposerFormStep2 = ({
  control,
  formValues,
  emailTemplate,
  getEmailTemplateVariables,
  goBack,
}: AcademicEmailComposerFormStep2Props) => {
  return (
    <div id="step-2" className="space-y-6">
      <div className="grid grid-cols-2 gap-4">
        <div className="flex rounded-md border border-gray-200 bg-white shadow-md dark:border-gray-700 dark:bg-gray-800 flex-col">
          <h2 className="text-lg font-semibold border-b p-4 mb-2">
            Email Preview
          </h2>
          {emailTemplate && (
            <EmailPreview
              emailTemplate={emailTemplate}
              emailTemplateVariables={getEmailTemplateVariables(formValues)}
              useEditorStyle={true}
            />
          )}
        </div>
        <div className="max-h-screen overflow-y-auto">
          <Controller
            name="salutation"
            control={control}
            rules={{
              required: "Signature is required",
            }}
            render={({ field, fieldState: { error } }) => {
              const { name, value, onBlur, disabled, onChange } = field;
              return (
                <TextInput
                  name={name}
                  value={value}
                  onBlur={onBlur}
                  onChange={onChange}
                  disabled={disabled}
                  required
                  label="Salutation"
                  placeholder="Salutation"
                  errorText={error?.message}
                />
              );
            }}
          />

          <Controller
            name="personalMessage"
            control={control}
            rules={{
              required: "Personal message is required",
            }}
            render={({ field, fieldState: { error } }) => {
              const { name, value, onBlur, disabled, onChange } = field;
              return (
                <RichTextInput
                  name={name}
                  value={value}
                  onBlur={onBlur}
                  disabled={disabled}
                  onChange={onChange}
                  required
                  placeholder="For coordinator to add personal message about the unit of study"
                  label="Personal Message"
                  className="[&>.ql-container]:min-h-48 "
                  errorText={error?.message}
                />
              );
            }}
          />

          <Controller
            name="signature"
            control={control}
            rules={{
              required: "Signature is required",
            }}
            render={({ field, fieldState: { error } }) => {
              const { name, value, onBlur, disabled, onChange } = field;
              return (
                <RichTextInput
                  name={name}
                  value={value}
                  onBlur={onBlur}
                  disabled={disabled}
                  onChange={onChange}
                  required
                  label="Signature"
                  className="[&>.ql-container]:min-h-24"
                  errorText={error?.message}
                />
              );
            }}
          />
          <div className="grid grid-cols-2 gap-4">
            <button
              type="button"
              onClick={goBack}
              className="text-brand bg-white border-2 border-brand focus:outline-none font-medium rounded-md text-md px-5 py-2.5 me-2 mb-2 w-full"
            >
              Back
            </button>

            <button
              name="next"
              type="submit"
              className="focus:outline-none text-white bg-brand font-medium rounded-md text-md px-5 py-2.5 me-2 mb-2 w-full"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AcademicEmailComposerFormStep2;
